import { SimpleDialog } from 'global/simple-dialog.src';
import accessFormValidation from './access-form';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    // define dialogs
    const accessBox = document.getElementById('accessBox');
    const thankYouBox = document.getElementById('thankYouBox');

    if (accessBox) {
        window.accessDialog = new SimpleDialog(accessBox);
    }

    if (thankYouBox) {
        const thankYouDialog = new SimpleDialog(thankYouBox);
        if (thankYouBox.querySelector('.download-pdf')) {
            thankYouBox.querySelector('.download-pdf').addEventListener('click', (e) => {
                thankYouDialog.hide();
            });
        }
        if (thankYouBox.querySelector('.continue-reading-online')) {
            thankYouBox.querySelector('.continue-reading-online').addEventListener('click', (e) => {
                e.preventDefault();
                thankYouDialog.hide();
            });
        }
    }

    // show fullAccessDialog
    if (typeof window.accessDialog === 'object') {
        let validationReady = false;
        [].forEach.call(document.querySelectorAll('[href="#accessBox"]'), (elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                window.accessDialog.show();
                if (validationReady === false) {
                    accessFormValidation();
                }
                validationReady = true;
            });
        });
        if (window.accessDialog.elem.classList.contains('simple-dialog-visible')) {
            if (validationReady === false) {
                accessFormValidation();
            }
            validationReady = true;
        }
    }
});
